export const AccountLogoutIcon = () => {
    return (
        <svg id="Layer_2" data-name="Layer 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17.33 17.37">
            <g id="Layer_1-2" data-name="Layer 1">
                <path className="cls-1"
                      d="M6.07,17.37h-.11c-4.13,0-5.97-1.84-5.97-5.97V5.97C0,1.84,1.84,0,5.97,0h.11c3.8,0,5.63,1.51,5.92,4.91,.04,.41-.27,.78-.68,.81-.42,.04-.78-.27-.81-.68-.22-2.58-1.42-3.54-4.43-3.54h-.11C2.67,1.5,1.5,2.67,1.5,5.97v5.43c0,3.3,1.17,4.47,4.47,4.47h.11c2.99,0,4.18-.94,4.42-3.48,.04-.41,.41-.71,.82-.68,.41,.04,.72,.4,.68,.82-.31,3.35-2.14,4.84-5.91,4.84Z"/>
                <path className="cls-1"
                      d="M15.65,9.42H6.17c-.41,0-.75-.34-.75-.75s.34-.75,.75-.75H15.65c.41,0,.75,.34,.75,.75s-.34,.75-.75,.75Z"/>
                <path className="cls-1"
                      d="M13.79,12.22c-.19,0-.38-.07-.53-.22-.29-.29-.29-.77,0-1.06l2.26-2.26-2.26-2.26c-.29-.29-.29-.77,0-1.06s.77-.29,1.06,0l2.79,2.79c.14,.14,.22,.33,.22,.53s-.08,.39-.22,.53l-2.79,2.79c-.15,.15-.34,.22-.53,.22Z"/>
            </g>
        </svg>
    )
}